import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";

/**
 * Redirects to the URL of the first external auth provider.
 * @param externalProviders the list of all external auth providers
 * @todo this function is not guaranteed to work unless only one external auth provider is set up (our original use case).
 */
const redirectToAuthProviderUrl = (externalProviders: ExternalProviderLinkModel[] | undefined) => {
    if (externalProviders) {
        const primaryAuthLink = getFirstAuthProviderUrl(externalProviders);
        window.location.href = primaryAuthLink;
    }
};

const getFirstAuthProviderUrl = (externalProviders: ExternalProviderLinkModel[] | undefined) => {
    if (externalProviders) {
        const firstProvider = externalProviders[0];
        // Since we are running our local environment on https, for some reason Epi is forcing this to http and it was breaking us on the 5.0.11.291 upgrade.
        const firstAuthProviderUrl = firstProvider.url.replace(":3000", "").replace("%3a3000", "");

        return firstAuthProviderUrl;
    }

    return "";
};

const getChangePasswordUrl = (externalProviders: ExternalProviderLinkModel[] | undefined) => {
    if (externalProviders) {
        const firstProviderUrl = getFirstAuthProviderUrl(externalProviders);
        const changePasswordUrl = firstProviderUrl
            .replace(":3000", "")
            .replace("%3a3000", "")
            .replace("signup_signin", "PasswordReset");
        return changePasswordUrl;
    }

    return "";
};

export { redirectToAuthProviderUrl, getFirstAuthProviderUrl, getChangePasswordUrl };
